import React from 'react';
import Table from '../../components/common/Table';

interface CompanyInfoTableProps {
  services: any[];
  handleEdit: (service: any) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const CompanyInfoTable: React.FC<CompanyInfoTableProps> = ({
  services,
  handleEdit,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        // Properties will be inserted here
        { label: 'Name', key: 'name' },
        { label: 'Email', key: 'email', className: 'hidden sm:table-cell' },
        { label: 'Phone', key: 'phone', className: 'hidden sm:table-cell' },
        { label: 'Address', key: 'address', className: 'hidden sm:table-cell' },
        { label: 'Bank', key: 'bank', className: 'hidden sm:table-cell' },
        { label: 'Account Type', key: 'accountType', className: 'hidden sm:table-cell' },
        { label: 'Branch Code', key: 'branchCode', className: 'hidden sm:table-cell' },
        { label: 'Account Number', key: 'accountNumber', className: 'hidden sm:table-cell' },
        { label: 'Swift Code', key: 'swiftCode', className: 'hidden sm:table-cell' },
      ]}
      data={services}
      actions={{
        onEdit: handleEdit,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default CompanyInfoTable;
